import { Divider } from "@mui/material";
import { FooterContainer, FooterLogoArea, FooterSection, FooterNavigation, FooterLinks, FooterContactInfo, FooterSocialLinks, FooterLegalNotice } from "./styles";
import { SVGFacebook2 } from "@assets/SVGFacebook2";
import { SVGInstagram } from "@assets/SVGInstagram";
import { SVGLinkedin } from "@assets/SVGLinkedin";
import { SVGXIcon } from "@assets/SVGXIcon";
import { FOOTER_LINKS } from './constants';

const Footer = () => {
  const date = new Date().getFullYear();

  return (
    <FooterSection>
      <FooterContainer>
        <FooterLogoArea>
          <img src="https://storage.googleapis.com/cdn.sendspark.com/share/themes/apm/logo.svg" alt="APM Logo" />
          <Divider orientation="vertical" variant="middle" flexItem />
          <p>Creating Experiences That Matter.</p>
        </FooterLogoArea>

        <FooterNavigation>
          <FooterLinks>
            {FOOTER_LINKS.map((link) => (
              <li key={link.title}>
                <a href={link.url} target="_blank">{link.title}</a>
              </li>
            ))}
          </FooterLinks>

          <FooterContactInfo>
            <div>
              <h3>Contact</h3>
              <p>
                American Pacific Mortgage<br />
                Corporate Office<br />
                3000 Lava Ridge Court<br />
                Suite 200<br />
                Roseville, CA 95661<br />
              </p>
              <a href="tel:916.960.1325">916.960.1225</a>
            </div>

            <FooterSocialLinks>
              <a href="https://www.facebook.com/americanpacificmortgage" target="_blank">
                <SVGFacebook2 width="24" height="24" color="#FFFFFF" />
              </a>
              <a href="https://www.linkedin.com/company/american-pacific-mortgage" target="_blank">
                <SVGLinkedin width="24" height="24" color="#FFFFFF" />
              </a>
              <a href="https://www.instagram.com/ap_mortgage/" target="_blank">
                <SVGInstagram width="24" height="24" color="#FFFFFF" />
              </a>
              <a href="https://x.com/AP_Mortgage" target="_blank">
                <SVGXIcon width="24" height="24" color="#FFFFFF" />
              </a>
            </FooterSocialLinks>
          </FooterContactInfo>
        </FooterNavigation>

        <FooterLegalNotice>
          <p>NMLS CONSUMER ACCESS LINK: NMLS #1850</p>
          
          <p>All information contained herein is for informational purposes only and, while every effort has been made to ensure accuracy, no guarantee is expressed or implied. Any programs shown do not demonstrate all options or pricing structures. Rates, terms, programs and underwriting policies subject to change without notice. This is not an offer to extend credit or a commitment to lend. All loans subject to underwriting approval. Some products may not be available in all states and restrictions apply. Equal Housing Opportunity</p>
          
          <p>Copyright &copy; {date} American Pacific Mortgage Corporation</p>
          
          <p>
            <a href="https://www.apmortgage.com/privacy-policy" target="_blank">Privacy Policy</a>
            <span>|</span>
            <a href="https://www.apmortgage.com/state-license-info" target="_blank">Legal/Licensing</a>
            <span>|</span>
            <a href="https://cdn2.hubspot.net/hubfs/450717/compliance%20notices/APM%20Accessibility%20Statement.pdf" target="_blank">Accessibility Statement</a>
            <span>|</span>
            <a href="https://app.hubspot.com/content/450717/edit/28825444614/content?__hsfp=33693536&__hssc=183439865.1.1745244321433&__hstc=183439865.a356bafdc6346d98273104062598244e.1744743898727.1744829356430.1745244321433.5&utm_source=sprocket-menu" target="_blank">Contact Us</a>
          </p>
        </FooterLegalNotice>
      </FooterContainer>
    </FooterSection>
  )
}

export default Footer;